import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import SettingsMenu from 'modules/settings-menu/index.js';

const { Popup, Button, Image, AbsolutePane, ImageButton } = MojitoPresentation.Components;

export default class SettingsMenuPopup extends MojitoCore.Presentation.UIViewImplementation {
    constructor(...args) {
        super(...args);

        this.state = {
            isSettingsMenuPopupOpen: false,
        };

        this.onSettingsButtonClicked = this.onSettingsButtonClicked.bind(this);
        this.onSettingsMenuClose = this.onSettingsMenuClose.bind(this);
    }

    onSettingsButtonClicked() {
        this.setState(state => ({
            isSettingsMenuPopupOpen: !state.isSettingsMenuPopupOpen,
        }));
    }

    onSettingsMenuClose() {
        this.setState({ isSettingsMenuPopupOpen: false });
    }

    render() {
        const { isSettingsMenuPopupOpen } = this.state;
        return (
            <Button
                config={this.config.button}
                onClick={this.onSettingsButtonClicked}
                active={isSettingsMenuPopupOpen}
                class="ta-settingsButton"
            >
                <Image
                    config={this.config.icon}
                    fill={this.config.iconColor[isSettingsMenuPopupOpen ? 'open' : 'closed']}
                />
                {isSettingsMenuPopupOpen && (
                    <Popup
                        visible={isSettingsMenuPopupOpen}
                        config={this.config.popup}
                        class="ta-settingsMenu"
                        onOutsideClick={this.onSettingsMenuClose}
                    >
                        <AbsolutePane config={this.config.closeButtonContainer}>
                            <ImageButton
                                class="ta-Dialog-closeButton"
                                onClick={this.onSettingsMenuClose}
                                config={this.config.closeButton}
                            />
                        </AbsolutePane>
                        <SettingsMenu config={this.config.settingsMenu} />
                    </Popup>
                )}
            </Button>
        );
    }
}
